import React from 'react';

import styled from 'styled-components';

import Icon from './icon';

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  svg {
    width: 10rem;
  }
`;

const BrandIcon = () => {
  return (
    <IconContainer>
      <Icon />
    </IconContainer>
  );
};

export default BrandIcon;
